// extracted by mini-css-extract-plugin
export default {"select":"Select_select__SDSSN","extraSmall":"Select_extraSmall__aEtgp","small":"Select_small__iLQJw","middle":"Select_middle__gg1o0","large":"Select_large__tYnP1"};